<div class="text-center mb-5">
    <h1 class="fw-bold mb-3">
        Sign In to HOAStart
    </h1>
    <button class="btn btn-lg btn-primary mt-3" (click)="logIn()">Sign in</button>
</div>
